import {
  Body,
  VStack,
  UnorderedList,
  ListItem,
  Box,
  Link,
} from '@hover/blueprint';
import React from 'react';
import { Link as GatsbyLink } from 'gatsby';

const DescriptionOct2020: React.FC = () => (
  <VStack
    spacing={600}
    alignItems="flex-start"
    mb={{ base: 900, tablet: '56px' }}
  >
    <Body>
      HOVER is a platform that allows individuals and businesses to create
      virtual accounts for homes, including accurate, digital 3D models of a
      property. Our users either own, reside in, or otherwise have a personal
      connection with a property or are Hover Inc. business partners that
      provide services or supplies to a property.
    </Body>
    <Box flexDir="column" alignItems="flex-start">
      <Body as="h2">HOVER users:</Body>
      <UnorderedList ml={0}>
        <ListItem>
          <Body>
            Are homeowners or current residents (either a “Resident”) of a
            subject property with HOVER
          </Body>
        </ListItem>
        <ListItem>
          <Body>
            Are contractors who create property estimates based on a HOVER 3D
            model
          </Body>
        </ListItem>
        <ListItem>
          <Body>
            Are insurers who underwrite property insurance policies or process
            property damage claims for their clients
          </Body>
        </ListItem>
      </UnorderedList>
    </Box>
    <Body>
      This Privacy Policy explains how we collect, use, share and protect
      personal data that is collected by HOVER to provide these and other
      services. It applies to the HOVER service (also referred to as “Service”),
      which includes our website at{' '}
      <Link as={GatsbyLink} to="/" fontWeight={400}>
        www.hover.to
      </Link>
      , our mobile application, and any other HOVER asset that links to this
      Privacy Policy.
    </Body>
    <Body>
      If you are a business using HOVER as part of a paid relationship between
      Hover Inc. and one of our partners, an enterprise agreement likely applies
      to the personal data collected through your use of HOVER that allows for
      sharing of data collected from your account with that business partner.
      You should contact your Hover Inc. partner to understand what additional
      policies apply to your personal data.
    </Body>
    <Body>
      Personal information is always governed by the rights of the Resident it
      relates to. For some accounts, the way data is collected or received may
      result in personal information of another individual in your account. If
      that other individual is a Resident, they will always retain rights over
      that information regardless of account ownership. For example, if you are
      part of a business and create a model for a homeowner, that homeowner
      cannot be denied access to contents of your account that relate to
      information you collected from or about them.
    </Body>
  </VStack>
);

export default DescriptionOct2020;
